import { TAction, TActionRequest } from "../../base/types/redux";
import {
  LoginRequest,
  GetUserInfoResponse,
  ApiStateType
} from "../utils/types";
import { ACTION_TYPES } from "./actionTypes";

export const login = (params: LoginRequest): TActionRequest<LoginRequest> => {
  return {
    type: ACTION_TYPES.LOGIN,
    params,
  };
};

export const setLoginState = (response: ApiStateType): TAction => {
  return {
    type: ACTION_TYPES.SET_LOGIN_STATE,
    response,
  };
};

export const setUserInfo = (response: GetUserInfoResponse): TAction => {
  return {
    type: ACTION_TYPES.SET_USER_INFO,
    response,
  };
};